import { render, staticRenderFns } from "./EditPop.vue?vue&type=template&id=18d0ad7c&scoped=true&"
import script from "./EditPop.vue?vue&type=script&lang=js&"
export * from "./EditPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d0ad7c",
  null
  
)

export default component.exports